export default __webpack_public_path__ + "static/media/gt.1ca5c25b.PNG";